import { connect } from 'react-redux';
import { getRescheduledInformation } from '../../../actions/entities/treatmentInstances/getRescheduledInformation';
import PatientRescheduledInformationDialogOpener from '../../../components/Patients/Patient/PatientRescheduledInformationDialogOpener';
import { showDialog } from '../../../actions/uiElements';

const mapStateToProps = ({ uiElements: { dialogs } }) => ({ dialogs });

const mapDispatchToProps = dispatch => ({
  getRescheduledInformation: treatmentInstanceId => dispatch(getRescheduledInformation(treatmentInstanceId)),
  show: id => dispatch(showDialog(id)),
});

const PatientRescheduledInformationDialogOpenerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientRescheduledInformationDialogOpener);

export default PatientRescheduledInformationDialogOpenerContainer;
